import React, { ComponentProps, ElementType, ReactNode } from 'react';

type DynamicContainerProps<T extends ElementType> = {
    children: ReactNode;
    className?: string;
    tag: T;
    displayTag?: boolean;
} & ComponentProps<T>;

const DynamicContainer = <T extends ElementType>({ 
    displayTag = false, 
    children, 
    className, 
    tag, 
    ...rest 
}: DynamicContainerProps<T>): JSX.Element => {
    const Tag = tag;

    return displayTag ? <Tag className={className || ''} {...rest}>{children}</Tag> : <>{children}</>;
};

export default DynamicContainer;